'use strict';

module.exports = function ValidationSuccess() {
  this.isValid = true;
  this.failureMessages = null;
};